import {
  Backdrop,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Paper,
  Portal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useOrderHandler } from "../../hooks/rest";

const useStyles = makeStyles((theme) => ({
  modal: {
    width: "500px",
  },
  label: {
    marginBottom: "10px",
  },
}));
export default function SelectWarehouseModal({
  isOpen,
  setOpen,
  order,
  warehouses,
  itemWarehouse,
  updateOrderDetails,
  children,
}: any) {
  const { updateOrderItemFfmCenter } = useOrderHandler();

  const classes = useStyles();

  const [checkboxValues, setCheckboxValues] = React.useState({});
  const [selectedWarehouse, setSelectedWarehouse] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [fulfillmentName, setFulfillmentName] = React.useState<string>("");
  const [warehousesFiltered, setWarehousesFiltered] = React.useState();

  useEffect(() => {
    if (itemWarehouse && warehouses) {
      let newRadioValues: any = {};
      warehouses.forEach((warehouse: any) => {
        newRadioValues[warehouse.fulfillmentCenterId] =
          warehouse.fulfillmentCenterId ===
          itemWarehouse.orderShipment.fulfillmentCenter.fulfillmentCenterId;
      });
      setCheckboxValues(newRadioValues);
    }
  }, [itemWarehouse, warehouses]);

  useEffect(() => {
    if (warehouses) {
      setWarehousesFiltered(warehouses);
    }
  }, [warehouses]);

  const handleWarehouseChange = (newWarehouse: any) => {
    let newCheckValues: any = {};
    warehouses.forEach((warehouse: any) => {
      newCheckValues[warehouse.fulfillmentCenterId] =
        warehouse.fulfillmentCenterId === newWarehouse.fulfillmentCenterId;
    });
    setCheckboxValues(newCheckValues);
    setSelectedWarehouse(newWarehouse);
  };
  const handleConfirmWarehouseChange = () => {
    if (selectedWarehouse && order && itemWarehouse) {
      setLoading(true);
      const [respUpdateOrderItemFfmCenter] = updateOrderItemFfmCenter({
        ffmCenterIdentifier: selectedWarehouse.identifier,
        orderId: order.orderId,
        orderItemId: itemWarehouse.orderItemId,
        storeId: order.store.storeId,
      });
      respUpdateOrderItemFfmCenter
        .then((resp) => {
          updateOrderDetails();
          setLoading(false);
          setOpen(false);
          setFulfillmentName("");
        })
        .catch(() => {
          // TODO Handle Error
          setLoading(false);
        });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setFulfillmentName("");
  };

  const handleFulfillmentChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const fulfillment: string = event.target.value.toLowerCase().trim();
    setFulfillmentName(fulfillment);

    if (!fulfillment || fulfillment === "") {
      setWarehousesFiltered(warehouses);
      return;
    }

    const filteredFulfillments = warehouses.filter((warehouse: any) => {
      if (!warehouse || !warehouse.name) {
        return true;
      }
      const warehouseName: string = warehouse.name.toLowerCase();
      return warehouseName.includes(fulfillment);
    });

    setWarehousesFiltered(filteredFulfillments);
  };

  return (
    <>
      <Dialog open={isOpen} onClose={handleClose}>
        <div className={classes.modal}>
          <DialogTitle>
            <Typography
              variant="body1"
              className={classes.label}
              style={{ marginRight: "75px" }}>
              <b>Producto</b>: {itemWarehouse ? itemWarehouse.productName : ""}
            </Typography>
            <Typography variant="body1" className={classes.label}>
              <b>SKU</b>: {itemWarehouse ? itemWarehouse.sku : ""}{" "}
            </Typography>
            <Typography variant="body1" className={classes.label}>
              <b>Bodega</b>:{" "}
            </Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              value={fulfillmentName}
              onChange={handleFulfillmentChange}></TextField>
            <Button
              onClick={handleClose}
              style={{
                position: "absolute",
                top: 8,
                right: 8,
              }}>
              X
            </Button>
          </DialogTitle>
          <DialogContent style={{ paddingTop: "0" }}>
            <TableContainer component={Paper}>
              <Table aria-label="Bodegas disponibles">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ paddingLeft: "45px" }}>
                      Bodega
                    </TableCell>
                    <TableCell>Cantidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {warehousesFiltered &&
                    warehousesFiltered.map((warehouse) => (
                      <TableRow key={warehouse.fulfillmentCenterId}>
                        <TableCell>
                          <Checkbox
                            checked={
                              checkboxValues[warehouse.fulfillmentCenterId] ||
                              false
                            }
                            onChange={(event) =>
                              handleWarehouseChange(warehouse)
                            }
                            style={{ borderRadius: "50%" }}
                          />
                          {warehouse.name}
                        </TableCell>
                        <TableCell>{warehouse.inventory.quantity}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleConfirmWarehouseChange}
              variant="contained"
              color="primary">
              Cambiar Bodega
            </Button>
          </DialogActions>
        </div>
      </Dialog>
      <Portal>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 2000,
          }}
          style={{
            zIndex: 2000,
          }}
          open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Portal>
    </>
  );
}
